import CustomerState from 'infrastructure/store/customer/CustomerState';
import IAppState from 'infrastructure/store/IAppState';
import React, { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { CustomerRole } from '../enums/customerRole';

interface Props {
  children: ReactNode;
  enabledRoles: CustomerRole | CustomerRole[];
  unauthorizedRender?: () => JSX.Element;
}

const RolesChecker = ({ children, enabledRoles, unauthorizedRender }: Props) => {
  // store
  const customerState = useSelector<IAppState, CustomerState>((store) => store.customer);
  
  // helpers
  const hasCustomerEnabledRole = (): boolean => {
    const customerRoles = customerState.customer.roles ?? [];
    let hasRole = false;

    if (Array.isArray(enabledRoles)) {
      for (const enabledRole of enabledRoles) {
        let foundRole = customerRoles.find(x => x === enabledRole);
        if (foundRole !== undefined) {
          hasRole = true;
          break;
        }
      }
    } else {
      let foundRole = customerRoles.find(x => x === enabledRoles);
      hasRole = foundRole ? true : false;
    }

    return hasRole;
  }

  // render
  if (hasCustomerEnabledRole()) {
    return (
      <>
        {children}
      </>
    );
  } else if (unauthorizedRender) {
    return unauthorizedRender();
  } else {
    return null;
  }
}

export default RolesChecker;
